import { render } from "./MarketplaceCard.vue?vue&type=template&id=5c0f53f8&scoped=true"
import script from "./MarketplaceCard.vue?vue&type=script&lang=js"
export * from "./MarketplaceCard.vue?vue&type=script&lang=js"

import "./MarketplaceCard.vue?vue&type=style&index=0&id=5c0f53f8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0f53f8"]])

export default __exports__